// Labels/colors shared by the Verification Center pages (match the backend's status mapping)
export const REVIEW_STATUS = {
  under_review: { label: "Pending Approval", color: "yellow" },
  clarification_requested: { label: "Clarification Required", color: "orange" },
  approved: { label: "Active", color: "green" },
  rejected: { label: "Rejected", color: "red" },
};

export const ACCOUNT_STATUS = {
  pending_approval: { label: "Pending Approval", color: "yellow" },
  clarification_required: { label: "Clarification Required", color: "orange" },
  active: { label: "Active", color: "green" },
  rejected: { label: "Rejected", color: "red" },
};

export const reviewStatusInfo = (status) => REVIEW_STATUS[status] || { label: status || "—", color: "gray" };
export const accountStatusInfo = (status) => ACCOUNT_STATUS[status] || { label: status || "—", color: "gray" };

export const formatDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const isUrl = (value) => typeof value === "string" && /^https?:\/\//i.test(value);
